module.exports = __webpack_public_path__ + "static/media/7.a1bcf064.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/7.png
// module id = 1502
// module chunks = 0